import React from 'react';
import {CircularProgress, CircularProgressProps} from '@mui/material';

const Loader = (props: CircularProgressProps) => {
  return <CircularProgress size={40} thickness={4} {...props} />;
};

export default Loader;
